module.exports = __webpack_public_path__ + "static/media/financeira-brb.16636d52.png";